// FIX: when slider gets to black cherry ice cream bar and wattamelon roll two three items get faded out instead of two
    // on big screens this bug also includes the jubilee roll and celebration cakes
    // FIXED, now have to apply a dynamic fix

var $sliderContainer = $(".slidesContainer .slides"),
    $allSlides = $(".slidesContainer .slide"),
    $prodName = $(".slideNav .prodName"),
    opac = 0.75;

// the slider only updates the product name after the first one has shifted to to the second
// so when the page loads we get the product name of the the first product and set that the
// current product name in the .slideNav .prodName element
var firstSlide = $sliderContainer.find(".slide").eq(0),
    firstSlideProdName = firstSlide.data("product-name"),
    firstSlideProdURL = firstSlide.data("product-url");

$prodName.html(firstSlideProdName);
$prodName.attr("href", firstSlideProdURL);

// get the first and last slide onload and fade their items out, this is done when the slide changes
// since this is only run starting when the slide changes we need an onload version
$sliderContainer.on("init", function(event, slick){
    var slides = slick.$slides,
        visibleSlides = $(".slick-active"),
        firstVisibleSlide = visibleSlides.eq(0),
        lastVisibleSlide = visibleSlides.eq(visibleSlides.length - 1);

    // firstVisibleSlide.css("opacity", opac);
    // lastVisibleSlide.css("opacity", opac);
});

var slider = $sliderContainer.slick({
    draggable: false,
    centerMode: true,
    centerPadding: "0px",
    slidesToShow: 5,
    cssEase: "ease-in-out",
    arrows: true,
    autoplay: true,
    autoplaySpeed: 3500,
    adaptiveHeight: true,
    infinite: true,
    lazyLoad: "ondemand",
    mobileFirst: true,
    prevArrow: '<i class="fa fa-chevron-left fa-2x" aria-hidden="true"></i>',
    nextArrow: '<i class="fa fa-chevron-right fa-2x" aria-hidden="true"></i>',
    responsive: [
    {
        breakpoint: 1299,
        settings: {
            slidesToShow: 7,
            slidesToScroll: 7
        }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 5
      }
    },
    {
      breakpoint: 319,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    }
  ]
});

var slideIndexAttr = [];
$allSlides.each(function () {
    slideIndexAttr.push($(this).data("slick-index"));
});

function applyOpacityShade(objs, direction){
    objs.each(function(index, object){
        var $obj = $(object);

        if(direction == "left"){
            if(index == 0 && !$obj.hasClass(".slick-center")){
                $obj.css("opacity", 0.5);
            } else if(index == 1 && !$obj.hasClass(".slick-center")){
                $obj.css("opacity", 0.75);
            }
        } else {
            if(index == 0 && !$obj.hasClass(".slick-center")){
                $obj.css("opacity", 0.75);
            } else if(index == 1 && !$obj.hasClass(".slick-center")){
                $obj.css("opacity", 0.5);
            }
        }
    });
}

function showLeftRigthImgs() {
    $(".slidesContainer .slide:not(.slick-active)").removeClass('onRight');

    var visibleSlides = $(".slick-active"),
        visibleLength = visibleSlides.length,
        halfVisible = visibleLength;

    if (halfVisible % 2 != 0) {
        halfVisible--;
    }

    halfVisible = halfVisible / 2;

    visibleSlides.each(function (index, object) {
        // console.log(object);

        if (index <= halfVisible) {
            if (index === 0) {
                $(this).prev().addClass('onLeft');
            }

            $(this).addClass('onLeft');
            $(this).removeClass('onRight');
        } else {
            if (index === visibleLength - 1) {
                $(this).next().addClass('onRight');
            }

            $(this).addClass('onRight');
            $(this).removeClass('onLeft');
        }
    }); 

    // left
    applyOpacityShade(visibleSlides.filter(".onLeft:not(.slick-center)"), "left");

    // right
    applyOpacityShade(visibleSlides.filter(".onRight"), "right");

    // center slide should always be 100% opacity
    $(".slick-center").css("opacity", 1);
}

showLeftRigthImgs();

// $sliderContainer.on("beforeChange", function (event, slick, currentSlide, nextSlide) {
//     showLeftRigthImgs();
// });

$sliderContainer.on("afterChange", function (event, slick, currentSlide, nextSlide) {
    showLeftRigthImgs();

    var slides = slick.$slides,
        curProduct = $(slides.get(currentSlide)),
        curProductName = curProduct.data("product-name"),
        curProductURL = curProduct.data("product-url"),
        visibleSlides = $(".slick-active");

    //$sliderContainer
    var centerSlide = $(".slick-center"),
    centerSlideProdName = centerSlide.data("product-name");

    $prodName.html(curProductName);
    $prodName.attr("href", curProductURL);


    // var currInd = slideIndexAttr.indexOf(centerSlide.data("slick-index"));
    // console.dir(slides);

    /*
    // put all the slides opacity back to 1
    slides.each(function(i, obj){
        $(obj).css("opacity", 1);
    });

    // make the first visible slide translucent
    visibleSlides.eq(0).css("opacity", opac);

    // make the last visible slide translucent
    visibleSlides.eq(visibleSlides.length - 1).eq(0).css("opacity", opac);

    visibleSlides.each(function (i, obj) {

        var $obj = $(obj),
            slideIndex = parseInt($obj.data("slick-index")) + 1,
            centerSlide = $(".slick-center"),
            centerSlideProdName = centerSlide.data("product-name");

        // have to make these dynamic now
        if(centerSlideProdName == "Wattamelon Roll®" && $obj.is(":visible") && slideIndex == 13){
            $obj.css("opacity", 1);
        }

        if(centerSlideProdName == "Jubilee Roll" && $obj.is(":visible") && slideIndex == -1){
            $obj.css("opacity", 1);
        }
    });

    */

    // console.log(curProductName);
    // console.log(visibleSlides);
});

// $(".slide").click(function(e){
//     var $this = $(this),
//         prodURL = $this.data("product-url");

//     window.location = prodURL;
// });

$sliderContainer.on('click', '.slide', function (e) {
    e.stopPropagation();

    var currentIndex = $('.slick-current').data("slick-index");
    var slideIndex = $(this).data("slick-index");

    if (currentIndex == slideIndex) {
        var $this = $(this),
        prodURL = $this.data("product-url");

        window.location = prodURL;
        return;
    } else {
        $sliderContainer.slick('slickGoTo', parseInt(slideIndex));
    }
});

$(".slideNavBtn").click(function(e){
    e.preventDefault();

    var $this = $(this),
        id = $this.attr("id");

    if (id == "prev") {
        $('.slick-current').addClass('onRight').removeClass('onLeft');
        $(".fa-chevron-left.slick-arrow").click();
    } else {
        $('.slick-current').removeClass('onRight');
        $(".fa-chevron-right.slick-arrow").click();
    }

    return false;
});